var _stop, _stop2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgIntro(props) {
  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.51 22.8H5.715c-.687 0-1.246-.582-1.246-1.297V2.497c0-.715.56-1.297 1.246-1.297H18.51c.687 0 1.247.582 1.247 1.297v19.006c0 .715-.56 1.297-1.247 1.297zm-6.397-3.46a.425.425 0 00-.416.432c0 .239.187.433.416.433.23 0 .415-.194.415-.433a.425.425 0 00-.415-.432zm-.831-16.41h1.662c.23 0 .416.193.416.432a.424.424 0 01-.416.432h-1.662a.424.424 0 01-.416-.432c0-.24.186-.433.416-.433zM9.72 7.433c-.329.198-.53.567-.53.966V15c0 .4.201.77.532.967a.996.996 0 001.073-.03l4.896-3.3c.303-.206.484-.559.484-.937s-.181-.73-.484-.935l-4.894-3.3a.992.992 0 00-1.077-.03zm.601.782l4.897 3.301c.055.037.09.107.09.184a.222.222 0 01-.09.183l-4.896 3.3a.154.154 0 01-.167.005.217.217 0 01-.099-.188V8.4c0-.081.04-.153.1-.19a.15.15 0 01.165.006z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 11.521,
    y1: 5.728,
    x2: 6.712,
    y2: 11.722,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC54BE"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5802D5"
  })))));
}

export default SvgIntro;